import React, { useEffect, useRef } from 'react';

// Two tilted tape bands under a hero, carrying the page's USP marquee — the
// Loop Foundry pattern: bands cross at opposite angles, run in opposite
// directions, and pick up speed while the page scrolls.
// Band 1 is the hero accent, band 2 the theme's text color (white in dark
// mode, ink in light mode).

const REPEAT = 4;

const HeroTapes = ({ items = [], accent, accentInk = '#ffffff' }) => {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const tracks = [...root.querySelectorAll('[data-tape]')];
    let pos = 0, last = window.scrollY, vel = 0, raf = 0, on = false;
    const step = () => {
      const dy = window.scrollY - last;
      last = window.scrollY;
      vel += (dy - vel) * 0.12;
      pos += 0.5 + Math.abs(vel) * 0.3;
      tracks.forEach((t) => {
        const half = t.scrollWidth / 2 || 1;
        const p = pos % half;
        t.style.transform = `translate3d(${+t.dataset.tape < 0 ? -p : p - half}px,0,0)`;
      });
      raf = on ? requestAnimationFrame(step) : 0;
    };
    // Only animate while the bands are on screen.
    const io = new IntersectionObserver(([e]) => {
      on = e.isIntersecting;
      if (on && !raf) { last = window.scrollY; raf = requestAnimationFrame(step); }
    });
    io.observe(root);
    return () => { io.disconnect(); cancelAnimationFrame(raf); };
  }, []);

  const band = (ink, dot) => Array.from({ length: REPEAT * 2 }, () => items).flat().map((label, i) => (
    <React.Fragment key={i}>
      <span className="hero-tape__label" style={{ color: ink }}>{label}</span>
      <span className="hero-tape__label" style={{ color: dot }}>✶</span>
    </React.Fragment>
  ));

  return (
    <div ref={rootRef} className="hero-tapes" aria-hidden="true">
      <div className="hero-tape hero-tape--1" style={{ backgroundColor: accent }}>
        <div className="hero-tape__track" data-tape="-1">{band(accentInk, accentInk)}</div>
      </div>
      <div className="hero-tape hero-tape--2">
        <div className="hero-tape__track" data-tape="1">{band('var(--bg-color)', accent)}</div>
      </div>
    </div>
  );
};

export default HeroTapes;
